import { IInventory } from ".";
import { IInventoryData } from "./inventory.type";

export class Inventory implements IInventory {
    iprcode: number;
    stock: number;

    constructor(data: IInventoryData) {
        this.iprcode = data.iprcode
        this.stock = data.stock
    }

    data(): IInventoryData {
        return Object.assign({}, this)
    }

}